/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_EmptyInputs */

const en_us2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the first set's load to work out a warm-up.`)
};

const pt_br2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina a carga da primeira série para calcular o aquecimento.`)
};

const es_419_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define el peso de la primera serie para calcular el calentamiento.`)
};

const pt_pt2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define a carga da primeira série para calcular o aquecimento.`)
};

const fr_fr2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique la charge de la première série pour calculer l'échauffement.`)
};

const de_de2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg das Gewicht des ersten Satzes fest, um ein Aufwärmen zu berechnen.`)
};

const it_it2_workout_logging_warmup_empty = /** @type {(inputs: Workout_Logging_Warmup_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta il carico della prima serie per calcolare il riscaldamento.`)
};

/**
* | output |
* | --- |
* | "Set the first set's load to work out a warm-up." |
*
* @param {Workout_Logging_Warmup_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_empty = /** @type {((inputs?: Workout_Logging_Warmup_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_empty(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_empty(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_empty(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_empty(inputs)
	return en_us2_workout_logging_warmup_empty(inputs)
});
export { workout_logging_warmup_empty as "workout-logging.warmup_empty" }